// @todo: Migrate to 'Icon' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {LegacyWBIcon} from '@wandb/weave/common/components/elements/LegacyWBIcon';
import {LinkNoCrawl} from '@wandb/weave/common/util/links';
import * as React from 'react';
import TimeAgo from 'react-timeago';
// eslint-disable-next-line wandb/no-deprecated-imports
import {Card} from 'semantic-ui-react';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

import {Project} from '../graphql/projects';
import * as urls from '../util/urls';
import {ProjectActionMenu} from './Project/ProjectActionMenu';
// @todo: Migrate to 'Skeleton' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Skeleton} from './Skeleton';

interface ProjectCardProps {
  isReadOnly?: boolean;
  project: Project;
}

const InlineSkeleton = styled(Skeleton)`
  display: inline-block;
  width: ${(props: {$width: number}) => props.$width}px;
`;

const SkeletonWrapper = styled.div`
  display: inline-flex;
  flex-grow: 1;
  justify-content: space-between;
`;

// the description line is only sometimes present which makes skeletons
// jumpy when they fill in
const ForcedHeightContent = styled(Card.Content)`
  min-height: 110px;
`;
const StyledContent = styled(Card.Content)`
  display: flex;
`;

export const ProjectCardSkeleton = () => (
  <div className="ui card project-card">
    <ForcedHeightContent>
      <Card.Header>
        <InlineSkeleton height={24} $width={120} />
      </Card.Header>
      <Card.Meta>
        <InlineSkeleton height={18} $width={50} />
      </Card.Meta>
      <Card.Description>
        <InlineSkeleton height={18} $width={220} />
      </Card.Description>
    </ForcedHeightContent>
    <StyledContent extra>
      <LegacyWBIcon name="summary" />
      <SkeletonWrapper>
        <InlineSkeleton $width={40} />
        <InlineSkeleton $width={100} />
      </SkeletonWrapper>
    </StyledContent>
  </div>
);

// projects w/ a lot of runs can have metadata overflow on project cards
const StyledSpan = styled.span`
  font-size: 14px;
`;
const ProjectCard = (props: ProjectCardProps) => {
  const {isReadOnly, project} = props;
  return (
    <LinkNoCrawl
      className="ui card project-card"
      key={project.id}
      to={urls.project(project)}>
      <ForcedHeightContent>
        {!isReadOnly && <ProjectActionMenu project={project} />}
        <Card.Header>{project.name}</Card.Header>
        <Card.Meta>{project.entityName}</Card.Meta>
        <Card.Description>{project.description}</Card.Description>
      </ForcedHeightContent>
      <Card.Content extra>
        <LegacyWBIcon name="summary" />
        {project.totalRuns ? project.totalRuns : 'No'} run
        {project.totalRuns === 1 ? '' : 's'}
        {project.lastActive && (
          <StyledSpan className="right floated">
            Last ran <TimeAgo date={project.lastActive} />
          </StyledSpan>
        )}
      </Card.Content>
    </LinkNoCrawl>
  );
};
export default ProjectCard;
